import { Injectable } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/database';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class FavoritesService {

  constructor(private db: AngularFireDatabase) { }

  addVideosFav(coursesId, userId, data) {
    // Firebase .update() throws if any value is `undefined` (e.g. replay
    // webinars often have no `product`), which silently broke "add to favorite".
    // Strip undefined values so the write always succeeds.
    const clean = {};
    Object.keys(data || {}).forEach((k) => {
      if (data[k] !== undefined) { clean[k] = data[k]; }
    });
    return this.db.database.ref('favorites/' + coursesId + '/favoritesVideos/' + userId).update(clean);
  }

  removeFavVideos(userId, id) {
    return this.db.list('favorites/' + userId + '/favoritesVideos/').remove(id);
  }

  getFavVideos(userId) {
    return this.db.list('favorites/' + userId + '/favoritesVideos/').snapshotChanges().pipe(
      map(changes =>
        changes.map(c => ({ key: c.payload, ...c.payload.val() as {} }),
        )
      )
    );
  }
}
